import { render } from "./studentNote.vue?vue&type=template&id=46f658ac&scoped=true"
import script from "./studentNote.vue?vue&type=script&lang=js"
export * from "./studentNote.vue?vue&type=script&lang=js"

import "./studentNote.vue?vue&type=style&index=0&id=46f658ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f658ac"]])

export default __exports__